<template>
  <div class="error-container">
    <el-result
      icon="error"
      title="页面加载失败"
      sub-title="很抱歉，页面资源加载失败，请尝试以下操作："
    >
      <template #extra>
        <div class="action-buttons">
          <el-button type="primary" @click="reloadPage">刷新页面</el-button>
          <el-button @click="clearCache">清除缓存并刷新</el-button>
          <el-button @click="goHome">返回首页</el-button>
        </div>
      </template>
      <div class="error-details">
        <p>如果问题持续存在，请尝试以下解决方案：</p>
        <ol class="solution-list">
          <li>清除浏览器缓存</li>
          <li>使用无痕/隐私模式打开</li>
          <li>尝试使用不同的浏览器</li>
          <li>联系系统管理员或技术支持</li>
        </ol>
        <p>错误信息: 资源加载失败 (ChunkLoadError)</p>
      </div>
    </el-result>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  methods: {
    reloadPage () { // 添加空格，移除分号
      window.location.reload()
    },
    clearCache () { // 添加空格，移除分号
      // 清除本地存储中可能导致问题的数据
      localStorage.removeItem('lastChunkError')
      localStorage.removeItem('chunkErrors')
      localStorage.removeItem('lastChunkReload')
      sessionStorage.clear()
      // 如果浏览器支持，尝试清除缓存
      if ('caches' in window) {
        try {
          caches.keys().then(names => {
            names.forEach(name => {
              caches.delete(name)
            })
          })
        } catch (e) {
          console.error('Failed to clear caches:', e)
        }
      }
      window.location.href = '/'
    },
    goHome () { // 添加空格，移除分号
      // 直接使用 window.location 而不是 router
      window.location.href = '/'
    }
  }
}
</script>

<style scoped>
.error-container {
  padding: 40px;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.action-buttons {
  margin: 20px 0;
}

.error-details {
  margin-top: 20px;
  color: #909399;
  font-size: 14px;
  text-align: left;
  background-color: #f8f8f8;
  padding: 15px;
  border-radius: 4px;
}

.solution-list {
  margin: 10px 0 10px 20px;
  line-height: 1.8;
}
</style>
